/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { DeliveryPanelProvider } from '@/data/context/deliveryLocationPanelCtx';
import { EmarsysProvider } from '@/data/context/emarsysCtx';
import { EventsProvider } from '@/data/context/events';
import { NotificationsProvider } from '@/data/context/notifications';
import { SessionDialogProvider } from '@/data/context/sessionDialogCtx';
import { SessionErrorProvider } from '@/data/context/sessionError';
import { StoreInventoryProvider } from '@/data/context/storeInventory';
import { ValidateLocaleRequestProvider } from '@/data/context/validateLocaleRequest';
import { FC, PropsWithChildren } from 'react';

export const AppContextProviders: FC<PropsWithChildren> = ({ children }) => (
	<EventsProvider>
		<SessionErrorProvider>
			<SessionDialogProvider>
				<NotificationsProvider>
					<ValidateLocaleRequestProvider>
						<EmarsysProvider>
							<DeliveryPanelProvider>
								<StoreInventoryProvider>{children}</StoreInventoryProvider>
							</DeliveryPanelProvider>
						</EmarsysProvider>
					</ValidateLocaleRequestProvider>
				</NotificationsProvider>
			</SessionDialogProvider>
		</SessionErrorProvider>
	</EventsProvider>
);
